<template>
  <div>
    <div class="menu-home" style="background-color: black; display: flex; align-items: center">
      <div class="container">
        <el-row type="flex">
          <!-- </el-row> class="row-bg" justify="end"> -->
          <el-col :md="4" :xs="4" :sm="2">
            <router-link to="/" :class="{ menuActivo: menuActivo === 'trabaja' }" v-scroll-to="{ el: '#trabaja', offset: 0 }">
              <img src="@/assets/new/login_blanco.svg" class="logo-home" @click="menuActivo = 'home'" alt="Login Farma"
            /></router-link>
          </el-col>

          <el-col :md="20" :sm="22">
            <div style="float: right; padding-right: 5%">
              <ul>
                <li>
                  <router-link to="/" :class="{ menuActivo: menuActivo == 'nosotros' }" v-scroll-to="{ el: '#nosotros', offset: 0 }" @click="menuActivo = 'nosotros'">
                    <!-- <a href="/" > -->
                    {{ $t('header.nosotros') }}
                    <!-- </a> -->
                  </router-link>
                </li>
                <li>
                  <router-link to="/" :class="{ menuActivo: menuActivo == 'servicios' }" v-scroll-to="{ el: '#servicios', offset: -100 }" @click="menuActivo = 'servicios'">
                    {{ $t('header.servicios') }}
                  </router-link>
                </li>

                <li>
                  <router-link to="/" :class="{ menuActivos: menuActivo == 'infra' }" v-scroll-to="{ el: '#infra', offset: 0 }" @click="menuActivo = 'infra'">
                    {{ $t('header.infraestructura') }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/" :class="{ menuActivos: menuActivo == 'calidad' }" v-scroll-to="{ el: '#calidad', offset: 0 }" @click="activarMenu('calidad')">
                    {{ $t('header.calidad') }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/trabaja-nosotros" :class="{ menuActivos: menuActivo === 'trabaja' }" v-scroll-to="{ el: '#', offset: 0 }" @click="scrollToTop">
                    {{ $t('header.trabaja') }}
                  </router-link>
                </li>

                <li>
                  <a href="https://log-in.com.ar/sala-de-prensa/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
                    {{ $t('header.prensa') }}
                  </a>
                </li>

                <li>
                  <router-link to="/" :class="{ menuActivos: menuActivo == 'contacto' }" v-scroll-to="{ el: '#contacto', offset: 100 }" @click="menuActivo = 'contacto'">
                    {{ $t('header.contacto') }}
                  </router-link>
                </li>

                <li>
                  <a
                    href="https://seguimiento.log-in.com.ar/#/"
                    style="background-color: #d35915; color: white; padding: 10px; font-family: 'MONTSERRAT-WHT'"
                    class="accesso"
                    target="_blank">
                    {{ $t('header.carro') }}
                    <i class="el-icon-caret-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<!--

 -->

<script>
import { EventBus } from '@/event-bus.js'
export default {
  data() {
    return { menuActivo: 'home' }
  },
  methods: {
    activarMenu(menu) {
      this.menuActivo = menu
      alert(menu)
      EventBus.$emit('menu-activo', menu)
    },
    scrollToTop() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
  },
}
</script>

<style lang="scss">
a:active {
  background-color: gray; /* Cambia el fondo a gris mientras se hace clic */
}
.menuActivos {
  color: #df5911 !important;
  font-weight: bold;
}
.menu-boton-carro {
  border: 1.4px solid $naranja;
  color: $naranja;
  margin-right: 10px;
  display: inline-block;
  padding: 3.1px 12px;
  border-radius: 12px;
  // transform: translateY(-9px);
  transition: all 0.3s;
}

.menu-boton-carro:hover {
  background: $naranja;
  color: white;
}

.menu-boton-webmail {
  border: 1.4px solid $azul;
  color: $azul;
  margin-right: 10px;
  display: inline-block;
  padding: 3.1px 12px;
  border-radius: 12px;
  transform: translateY(-9px);
  transition: all 0.3s;
}

.menu-boton-webmail:hover {
  background: $azul;
  color: white;
}
.es {
  height: 15px;
  display: inline-block;
  margin: 0 auto;
  margin-top: -20px;
  margin-left: 20px;
  padding: 6.1px 4px;
  cursor: pointer;
}
.en {
  height: 15px;
  display: inline-block;
  margin: 0 auto;
  margin-top: -20px;
  margin-left: 10px;
  padding: 6.1px 4px;
  cursor: pointer;
}

.menu-boton-ig img {
  height: 15.5px;

  margin: 0px;
  padding: 6px 4px;
  margin-top: -20px;
}
.menu-boton-in img {
  height: 17px;
  margin: 0px;
  padding: 7px 4px;
  margin-top: -20px;
}

.menu-boton-yt img {
  height: 13px;
  margin: 0px;
  padding: 7px 4px;
  margin-top: -20px;
}
.menu-boton-ig {
  position: relative;
  transition: 500ms;
  margin: 0px;
  padding: 0px;
  display: inline-block;
  margin-left: 10px;
}
.menu-boton-in {
  position: relative;
  transition: 500ms;
  margin: 0px;
  padding: 0px;
  display: inline-block;
}
.menu-boton-yt {
  position: relative;
  transition: 500ms;
  margin: 0px;
  padding: 0px;
  display: inline-block;
}

.menu-home {
  height: 55px;
  background: #fff;
  // -webkit-box-shadow: 0 1px 1px 0   rgba(94, 94, 94, 0.91) ;
  // box-shadow: 0 1px 1px 0 rgba(94, 94, 94, 0.91) ;
  position: relative;
  z-index: 99;
}

.logo-home {
  height: 50px;
  // margin-left: 50px;
  // text-align: center;
  // margin-top: 5px;
  // cursor: pointer;
}

.menu-home ul {
  list-style: none;
  padding: 0;
  display: inline-block;
  margin: 0;
  // margin-top: 12px;
  // transform: translateY(-8px);
  // margin-right: 20px;
  margin: 25px 0px;

  // margin-right: 10%;
}
.menu-home ul > li {
  display: inline;
  padding: 10px 12px;
  font-size: 14px;
}

.menu-home ul > li > a {
  // font-family: 'Asap', sans-serif;
  font-family: 'MONTSERRAT-WHT';
  text-decoration: none;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.97);
  text-transform: uppercase;
  line-height: 2.2;
  transition: all 0.5s;
  font-size: 14px;
}
.menu-home ul > li > a > .accesso {
  font-size: 12px !important;
}
.menu-home ul li a .accesso {
  font-size: 12px !important;
}
.menu-home ul > li > a:hover {
  color: #df5911;
  font-weight: bold;
}
.menu-home a.active {
  color: #df5911;
  font-weight: bold;
}
/*  */
@media (min-width: 2561px) {
  .menu-home ul > li > a {
    font-size: 16px;
  }
  .menu-home {
    height: 90px;
  }
  .accesso {
    font-size: 13px !important;
  }
  .logo-home {
    height: 70px;
    // margin-left: 87%;
    padding: 10px 0px 0px 57%;
    // text-align: center;
    // margin-top: 10px;
    // cursor: pointer;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .menu-home ul > li > a {
    font-size: 16px;
  }
  .menu-home {
    height: 90px;
  }
  .accesso {
    font-size: 13px !important;
  }
  .logo-home {
    height: 70px;
    // margin-left: 87%;
    padding: 10px 0px 0px 57%;
    // text-align: center;
    // margin-top: 10px;
    // cursor: pointer;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .menu-home ul > li > a {
    font-size: 15px;
  }
  .menu-home {
    height: 90px;
  }
  .accesso {
    font-size: 14px !important;
  }
  .logo-home {
    height: 70px;
    padding: 10px 0px 0px 57%;

    // margin-left: 87%;
    // text-align: center;
    // margin-top: 10px;
    // cursor: pointer;
  }
  .menu-home ul {
    // margin-top: 15px;
    margin: 29px 8px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .menu-home ul > li > a {
    font-size: 13px;
  }
  .menu-home {
    height: 90px;
  }
  .accesso {
    font-size: 12px !important;
  }
  .logo-home {
    height: 60px;
    padding: 10px 0px 0px 60%;
    // margin-left: 87%;
    // text-align: center;
    // margin-top: 15px;
    // cursor: pointer;
  }
  .menu-home ul {
    margin: 29px 8px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .menu-home {
    height: 70px;
    background: #fff;
    position: relative;
    z-index: 99;
  }
  .logo-home {
    height: 45px;
    padding: 10px 0px 0px 62%;
  }
  .menu-home ul {
    // margin-top: 15px;
  }
  .menu-home ul > li > a {
    font-size: 10px;
  }
  .accesso {
    font-size: 10px !important;
  }
  .menu-home ul > li {
    padding: 10px 3px;
  }
}
@media screen and (min-width: 720px) and (max-width: 1280px) {
  .menu-home ul > li > a {
    font-size: 11px;
  }
  .logo-home {
    height: 50px;
    padding: 7% 0px 7% 55%;
  }
  .accesso {
    font-size: 10px !important;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .menu-home ul > li > a {
    font-size: 12px;
  }
  .logo-home {
    height: 80px;
  }
}
</style>
